<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb"></breadcrumb>
    <div v-if="shopData.shopNum" v-loading="loading">
      <div class="button_wrap">
        <div>
          <!-- <span
            ><h4>{{ language("shopList.breadcrumbTitle") }}</h4></span
          > -->
          <template v-if="$menuList['SIS-Setting-ShopList-ShopStatus']">
            <div class="status"><h4>Status</h4></div>
            <el-button type="primary" @click="changeStatus(1)">{{
              language("shopList.online")
            }}</el-button>
            <el-button type="danger" @click="changeStatus(3)">{{
              language("shopList.offline")
            }}</el-button>
          </template>
        </div>
        <template v-if="$menuList['SIS-Setting-ShopList-Add']">
          <el-button type="primary" @click="open">{{
            language("shopList.add")
          }}</el-button>
        </template>
      </div>
      <el-divider></el-divider>
      <div class="count_tips">
        <div class="count_tips">
          {{ language("shopList.results") }} {{ results }}
          {{ language("shopList.rows") }}
        </div>
        <page :total="results" @pageChange="pageChange"></page>
      </div>

      <cc-table
        :loadData="false"
        :config="table"
        :params="params"
        :refeshParams="refeshTable"
        :emptyText="language('shopList.emptyText')"
        :showIndex="false"
        @selecting-result="selectingResult"
        :buttonsWidth="90"
        :dataArr="dataArr"
      ></cc-table>
    </div>

    <template v-if="dialog">
      <el-dialog
        :title="language('shopList.breadcrumbTitle')"
        :visible.sync="dialog"
        :close-on-click-modal="false"
        width="80%"
      >
        <div class="shop_info form">
          <el-tabs v-model="activeName">
            <el-tab-pane
              :label="language('shopInformation.tab1')"
              name="tab1"
            ></el-tab-pane>
            <el-tab-pane
              :label="language('shopInformation.tab2')"
              name="tab2"
            ></el-tab-pane>
            <el-tab-pane
              :label="language('shopInformation.tab3')"
              name="tab3"
            ></el-tab-pane>
            <el-tab-pane
              :label="language('shopInformation.tab4')"
              name="tab4"
            ></el-tab-pane>
            <el-tab-pane
              :label="language('shopInformation.tab5')"
              name="tab5"
            ></el-tab-pane>
          </el-tabs>
          <div v-show="activeName == 'tab1'">
            <el-form
              ref="form1"
              :rules="rules"
              :model="form1"
              label-width="220px"
              label-position="left"
            >
              <tab1 v-model="form1" :formData="form1"></tab1>
            </el-form>
          </div>
          <div v-show="activeName == 'tab2'">
            <el-form
              ref="form2"
              :model="form2"
              label-width="250px"
              label-position="left"
            >
              <tab2 v-model="form2" :formData="form2"></tab2>
            </el-form>
          </div>

          <div v-show="activeName == 'tab3'">
            <el-form
              ref="form3"
              :model="form3"
              label-width="280px"
              label-position="left"
            >
              <tab3 v-model="form3" :formData="form3"></tab3>
            </el-form>
          </div>
          <div v-show="activeName == 'tab4'">
            <el-form
              ref="form4"
              :model="form4"
              label-width="250px"
              label-position="left"
            >
              <tab4 v-model="form4" :formData="form4"></tab4>
            </el-form>
          </div>
          <div v-show="activeName == 'tab5'">
            <el-form
              ref="form5"
              :model="form5"
              label-width="260px"
              label-position="left"
              :rules="rules"
            >
              <tab5 v-model="form5" :formData="form5"></tab5>
            </el-form>
          </div>
          <el-button type="primary" @click="save">{{
            language("shopList.save")
          }}</el-button>
        </div>
      </el-dialog>
    </template>
  </div>
</template>
<script>
import breadcrumb from "../../components/breadcrumb";
import tab1 from "../shop/components/tab/tab1";
import tab2 from "../shop/components/tab/tab2";
import tab3 from "../shop/components/tab/tab3";
import tab4 from "../shop/components/tab/tab4";
import tab5 from "../shop/components/tab/tab5";
import page from "../../components/page";
export default {
  components: {
    breadcrumb,
    tab1,
    tab2,
    tab3,
    tab4,
    tab5,
    page,
  },
  data() {
    return {
      breadcrumb: {
        title: this.language("shopList.breadcrumbTitle"),
        list: [
          {
            name: this.language("shopList.breadcrumbList_1"),
          },
          {
            name: this.language("shopList.breadcrumbList_2"),
          },
        ],
      },
      table: {
        api: "admin/merchant/shop/queryAllByMerchantNum",
        showPager: false,
        selection: true,
        selectionNoSubmit: true,
        selectingResult: true,
        indexFixed: "left",
        columns: [
          // {
          //   prop: "id",
          //   lable: "ID",
          // },
          {
            prop: "nameChi",
            lable: this.language("shopList.shopNameChi"),
            minWidth: 130,
          },
          {
            prop: "nameEng",
            lable: this.language("shopList.shopNameEng"),
            minWidth: 130,
          },
          {
            prop: "shopNum",
            lable: this.language("shopList.merchantNum"),
          },
          {
            prop: "auditStatus",
            lable: this.language("shopList.audit"),
            type: "tag",
            options: {
              0: {
                tagType: "info",
                text: this.language("shopList.auditPending"),
              },
              1: {
                tagType: "success",
                text: this.language("shopList.auditApproved"),
              },
              2: {
                tagType: "danger",
                text: this.language("shopList.auditRejected"),
              },
              4: {
                tagType: "info",
                text: this.language("shopList.auditInitial"),
              },
            },
            minWidth: 90,
          },
          {
            prop: "status",
            lable: this.language("shopList.status"),
            type: "tag",
            minWidth: 70,
            options: {
              0: {
                tagType: "info",
                text: this.language("shopList.statusDeveloping"),
              },
              1: {
                tagType: "success",
                text: this.language("shopList.statusOnline"),
              },
              2: {
                tagType: "danger",
                text: this.language("shopList.statusFrozen"),
              },
              3: {
                tagType: "danger",
                text: this.language("shopList.statusOffline"),
              },
              4: {
                tagType: "info",
                text: this.language("shopList.statusInitial"),
              },
            },
          },
          {
            prop: "createTime",
            lable: this.language("shopList.createTime"),
            minWidth: 120,
          },
        ],
        buttons: [],
      },
      results: 100,
      dataArr: [],
      params: {},
      refeshTable: -1,
      dialog: false,
      activeName: "tab1",
      oldForm: {},
      form1: {},
      form2: {},
      form3: {},
      form4: {},
      form5: {},
      rules: {
        aliasName: [
          {
            //  required: true, message: "商店別名為空", trigger: "blur"
            validator: this.aliasName,
            trigger: "blur",
            required: true,
            message: this.language("shopList.shopAliasEmpty"),
          },
        ],
        nameChi: [
          {
            required: true,
            message: this.language("shopList.shopNameEmpty"),
            trigger: "blur",
          },
        ],
        nameEng: [
          {
            required: true,
            message: this.language("shopList.shopNameEmpty"),
            trigger: "blur",
          },
        ],
        categoryIds: [
          {
            required: true,
            message: this.language("shopList.categoryEmpty"),
            trigger: "blur",
          },
        ],
        logo: [
          {
            required: true,
            message: this.language("shopList.logoEmpty"),
            trigger: "blur",
          },
        ],
        colorTheme: [
          {
            required: true,
            message: this.language("shopList.colorThemeEmpty"),
            trigger: "blur",
          },
        ],
        topBannerImg: [
          {
            required: true,
            message: this.language("shopList.topBananerEmpty"),
            trigger: "blur",
          },
        ],
        mchShopBizTimes: [
          {
            validator: this.mchShopBizTimes,
            trigger: "blur",
            required: true,
          },
        ],
        mchShopBizTimes2: [
          {
            validator: this.mchShopBizTimes2,
            trigger: "blur",
            required: true,
          },
        ],
        mchShopBizTimes3: [
          {
            validator: this.mchShopBizTimes3,
            trigger: "blur",
            required: true,
          },
        ],
      },
      shopData: {},
      ids: [],
      loading: false,
      form: {
        pageSize: 10,
        pageNo: 1,
      },
    };
  },
  watch: {
    form5: {
      handler() {
        if (
          this.form5.mchShopBizTimes &&
          this.form5.mchShopBizTimes.length > 0
        ) {
          this.form5.mchShopBizTimes2 = [...this.form5.mchShopBizTimes];
          this.form5.mchShopBizTimes3 = [...this.form5.mchShopBizTimes];
        }
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    aliasName(rule, value, callback) {
      if (value == undefined || value == "") {
        callback(new Error(this.language("shopList.shopAliasMustNotEmpty")));
      } else {
        // var reg = /^[u4E00-u9FA5]+$/;
        // if (/.*[\u4e00-\u9fa5]+.*$/.test(value)) {
        //   callback(new Error("商店別名不能含有中文"));
        // }
        var r = /^[A-Za-z0-9_]*$/;
        if (!r.test(value)) {
          callback(new Error(this.language("shopList.shopNameTips")));
        }
        callback();
      }
    },
    mchShopBizTimes(rule, value, callback) {
      let num = 0;
      for (let i = 0; i < value[0].week.length; i++) {
        if (value[0].week[i].day > 0) {
          //普通時間
          if (
            value[0].week[i].isOnBussiness &&
            value[0].week[i].time &&
            value[0].week[i].time.length > 0
          ) {
            num += 1;
          }
        } else {
          //節假日
          // if (value[0].week[i].isOnBussiness) {
          //   num += 1;
          // }
        }
      }
      if (num == 0) {
        callback(new Error(this.language("shopList.businessChooseTips")));
      } else {
        callback();
      }
    },

    mchShopBizTimes2(rule, value, callback) {
      let num = 0;
      for (let i = 0; i < value[1].week.length; i++) {
        if (value[1].week[i].day > 0) {
          //普通時間
          if (
            value[1].week[i].isOnBussiness &&
            value[1].week[i].time &&
            value[1].week[i].time.length > 0
          ) {
            num += 1;
          }
        } else {
          //節假日
          // if (value[1].week[i].isOnBussiness) {
          //   num += 1;
          // }
        }
      }

      if (num == 0) {
        callback(new Error(this.language("shopList.businessChooseTips")));
      } else {
        callback();
      }
    },

    mchShopBizTimes3(rule, value, callback) {
      let num = 0;
      for (let i = 0; i < value[2].week.length; i++) {
        if (value[2].week[i].day > 0) {
          //普通時間
          if (
            value[2].week[i].isOnBussiness &&
            value[2].week[i].time &&
            value[2].week[i].time.length > 0
          ) {
            num += 1;
          }
        } else {
          //節假日
          // if (value[2].week[i].isOnBussiness) {
          //   num += 1;
          // }
        }
      }

      if (num == 0) {
        callback(new Error(this.language("shopList.businessChooseTips")));
      } else {
        callback();
      }
    },

    pageChange(e) {
      let form = {};
      form.pageSize = e.pageSize;
      form.pageNo = e.pageNo;
      this.ids = [];
      this.form = { ...form };
      this.getData(form);
    },

    getData(e) {
      this.loading = true;
      e.allShow = 1;
      this.ccRequest
        .do("admin/merchant/shop/user/rel/queryShopList", e)
        .then((res) => {
          this.dataArr = res.rows;
          this.results = res.total;
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;

          this.$message.error(err.response.data.message);
        });
    },
    open() {
      this.dialog = true;
      this.form1 = {};
      this.form2 = {};
      this.form3 = {};
      this.form4 = {};
      this.form5 = {
        mchShopBizTimes: [],
      };
      this.oldForm = {};
      this.activeName = "tab1";
    },
    selectingResult(e) {
      let ids = [];
      for (let i = 0; i < e.length; i++) {
        ids.push(e[i].id);
      }
      this.ids = ids;
    },
    changeStatus(status) {
      if (this.ids.length == 0) {
        this.$message.error(this.language("shopList.chooseShopListTips"));
        return false;
      }
      this.$confirm(
        this.language("common.changeTips"),
        this.language("common.tips"),
        {
          confirmButtonText: this.language("common.confirm"),
          cancelButtonText: this.language("common.cancel"),
          type: "warning",
        }
      )
        .then(() => {
          this.ccRequest
            .do(
              "admin/merchant/shop/batchChangeStatusInSis",
              { ids: this.ids, status: status },
              "POSTJSON"
            )
            .then((res) => {
              // this.refeshTable = new Date().getTime();
              this.getData(this.form);
              this.$message.success(this.language("shopInformation.success"));
              this.ids = [];
            })
            .catch((err) => {
              this.$message.error(err.response.data.message);
            });
        })
        .catch(() => {});
    },
    chekeForm(name) {
      return new Promise((resolve, reject) => {
        this.$refs[name].validate((valid) => {
          if (valid) {
            resolve();
          } else {
            reject();
          }
        });
      });
    },
    save() {
      let chekeForm = [this.chekeForm("form5")];
      if (this.$menuList["SIS-ShopDisplay-View/Edit Info.-Shop Info."]) {
        chekeForm.push(this.chekeForm("form1"));
      } else if (this.$menuList["SIS-ShopDisplay-View/EditInfo.-ShopDesc"]) {
        chekeForm.push(this.chekeForm("form2"));
      } else if (
        this.$menuList["SIS-ShopDisplay-View/EditInfo.-CustomerServices"]
      ) {
        chekeForm.push(this.chekeForm("form3"));
      } else if (this.$menuList["SIS-ShopDisplay-View/EditInfo.-T&C"]) {
        chekeForm.push(this.chekeForm("form4"));
      }
      let result = Promise.all(chekeForm);
      result
        .then((data) => {
          let form = { ...this.oldForm, ...this.saveForm() };
          if (form.id) {
            delete form.isAudit;
            delete form.auditStatus;
            delete form.auditRemark;
            delete form.auditIds;
          }
          this.ccRequest
            .do("admin/merchant/shop/save", form, "POSTJSON")
            .then((res) => {
              this.getData(this.form);
              this.$alert("待「一本」批核", "提示", {
                confirmButtonText: "確認",
                callback: (action) => {
                  this.$message({
                    message: this.language("shopInformation.success"),
                    type: "success",
                  });
                  this.dialog = false;
                },
              });
            })
            .catch((err) => {
              this.$message.error(err.response.data.message);
            });
        })
        .catch((err) => {
          console.log(err);
          this.$message.error(this.language("common.incorrectInfo"));
        });
    },
    saveForm() {
      let langList = [];
      let form = {};
      if (this.form1.langList) {
        langList = [...langList, ...this.form1.langList];
        delete this.form1.langList;
      }
      if (this.form2.langList) {
        langList = [...langList, ...this.form2.langList];
        delete this.form2.langList;
      }
      if (this.form3.langList) {
        langList = [...langList, ...this.form3.langList];
        delete this.form3.langList;
      }
      if (this.form4.langList) {
        langList = [...langList, ...this.form4.langList];
        delete this.form4.langList;
      }
      if (this.form5.langList) {
        langList = [...langList, ...this.form5.langList];
        delete this.form5.langList;
      }
      let mchShopBizTimes = [
        ...this.form5.mchShopBizTimes[0].week,
        ...this.form5.mchShopBizTimes[1].week,
        ...this.form5.mchShopBizTimes[2].week,
      ];
      for (let i = 0; i < mchShopBizTimes.length; i++) {
        if (mchShopBizTimes[i].isOnBussiness) {
          if (mchShopBizTimes[i].day > 0) {
            if (mchShopBizTimes[i].closeTime || mchShopBizTimes[i].openTime) {
              mchShopBizTimes[i].isOnBussiness = 1;
            } else {
              mchShopBizTimes[i].isOnBussiness = 0;
            }
          } else {
            if (mchShopBizTimes[i].isOnBussiness) {
              mchShopBizTimes[i].isOnBussiness = 1;
            } else {
              mchShopBizTimes[i].isOnBussiness = 0;
            }
          }
        } else {
          mchShopBizTimes[i].isOnBussiness = 0;
        }
      }
      form = {
        ...this.form1,
        ...this.form2,
        ...this.form3,
        ...this.form4,
        merchantNum: this.shopData.merchantNum,
        mchShopBizTimes: mchShopBizTimes,
      };
      form.langList = langList;
      return form;
    },
    setActiveName() {
      if (this.$menuList["SIS-ShopDisplay-View/Edit Info.-Shop Info."]) {
        this.activeName = "tab1";
      } else if (this.$menuList["SIS-ShopDisplay-View/EditInfo.-ShopDesc"]) {
        this.activeName = "tab2";
      } else if (
        this.$menuList["SIS-ShopDisplay-View/EditInfo.-CustomerServices"]
      ) {
        this.activeName = "tab3";
      } else if (this.$menuList["SIS-ShopDisplay-View/EditInfo.-T&C"]) {
        this.activeName = "tab4";
      } else {
        this.activeName = "tab5";
      }
    },
    edit(row) {
      this.ccRequest
        .do(
          // "admin/merchant/shop/audit/getAuditInfo",
          // { shopId: row.id },
          "admin/merchant/shop/get",
          { id: row.id },
          "GET"
        )
        .then((res) => {
          this.dialog = true;

          this.oldForm = { ...res };
          this.form1 = { ...res };
          this.form2 = { ...res };
          this.form3 = { ...res };
          this.form4 = { ...res };
          this.form5 = { ...res };

          this.setActiveName();
        })
        .catch((err) => {
          this.$message.error(err.response.data.message);
        });
    },
  },
  mounted() {
    this.shopData = this.$shopData;
    this.getData({
      pageSize: 10,
      pageNo: 1,
    });
    if (this.$menuList["SIS-Setting-ShopList-Edit"]) {
      this.table.buttons.push({
        name: this.language("shopList.edit"),
        click: (row, index) => {
          this.edit(row);
        },
      });
    }
  },
};
</script>
<style></style>
<style scoped lang="scss">
.button_wrap {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.count_tips {
  margin: 10px 0 20px 0;
}
.status {
  display: inline-block;
  margin-top: 8px;
  margin-right: 16px;
}
.count_tips {
  margin: 10px 0 20px 0;
  display: flex;
  justify-content: space-between;
  // font-size: $sbuTitle;
  font-weight: 600;
}
</style>
